import { uniqBy } from 'lodash'
import generate from './tools/generate'
import api from '@/plugins/api'
import createFormData from '@/tools/createFormData'

function input() {
    return {
        label: null,
        fieldId: null,
        difficultyIndexId: null,
        image: null,
        question: null,
        answers: [null],
        correctAnswerIdx: null,
        explanationVideoUrl: null,
        explanationVideoId: null,
        verified: null,
        isExplanationImagesChanged: false,
        explanationImages: [],
    }
}

function questionbank() {
    return {
        questions: null,
        input: input(),
        fields: [],
        labels: [],
        selectedQuestionId: null,
    }
}

const getters = {
    inputFormData(state) {
        const data = {
            label: state.input.label,
            field_id: state.input.fieldId,
            image: state.input.image,
            difficulty_index_id: state.input.difficultyIndexId,
            question: state.input.question,
            answers: state.input.answers,
            correct_answer_idx: state.input.correctAnswerIdx,
            explanation_video_id: state.input.explanationVideoId,
            verified: state.input.verified,
            is_explanation_images_changed: state.input.isExplanationImagesChanged ? '1' : '0',
        }

        if (state.input.isExplanationImagesChanged) {
            data.explanation_images = state.input.explanationImages
        }

        return createFormData(data)
    }
}

const mutations = {
    ...generate.mutations(questionbank()),

    APPEND_LABEL(state, label) {
        state.labels.push(label)
    },

    RESET_INPUT(state) {
        Object.assign(state.input, input())
    },
}

const actions = {
    getQuestions({ commit }, questionbank_id) {
        api.get(`questionbank/${questionbank_id}/question`, { loader: 'appbar' })
            .then(response => {
                commit('SET_QUESTIONS', response.data.questions)

                const labels = uniqBy(response.data.questions, 'label').map(e => {
                    return e.label
                })

                commit('SET_LABELS', labels)
            })
    },
}

export default {
    namespaced: true,
    state: questionbank(),
    getters,
    mutations,
    actions,
}
